import { parse, ParseResult } from 'papaparse';

export interface ColumnValidationResult {
  found: string[];
  missing: string[];
}

export interface CsvParseResult<T> {
  data: any[];
  columnValidation: ColumnValidationResult;
  isValid: boolean;
}

const normaliseData = (s: string): string => s.trim().toLowerCase();

const parseCsvAndValidateColumns = (
  fileText: string,
  requiredColumns: string[]
): CsvParseResult<any> => {
  const result: ParseResult<any> = parse<any>(fileText, {
    header: true,
    skipEmptyLines: true,
  });

  const detectedHeaders: string[] = result.meta.fields ?? [];

  const normalisedDetected = new Set(
    detectedHeaders.map((header: string) => normaliseData(header))
  );

  const found: string[] = [];
  const missing: string[] = [];

  for (const required of requiredColumns) {
    if (normalisedDetected.has(normaliseData(required))) {
      found.push(required);
    } else {
      missing.push(required);
    }
  }

  return {
    data: result.data,
    columnValidation: { found, missing },
    isValid: missing.length === 0,
  };
}

const parseBoolean = (val: string | undefined): boolean => {
  if (!val) return false;
  const lower = val.trim().toLowerCase();
  return lower === 'yes' || lower === 'true' || lower === '1';
};

const trimOrEmpty = (val: string | undefined): string => val?.trim() ?? '';

export {
  normaliseData,
  parseCsvAndValidateColumns,
  parseBoolean,
  trimOrEmpty
}